import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Section from "../../components/Section";
import Icons from "../../components/Icons";
import { useSubscription, useQuery } from "@apollo/client";
import juriesUpdate from "../../helpers/juriesUpdate";
import { useHistory } from "react-router";
import { GET_JURIES, SUB_JURIES } from "../../graphql_tags";

const FinishSection = styled(Section)`
  flex-direction: column;
  margin-top: 30px;
`;

const FinishCard = styled.div`
  display: flex;

  div {
    padding: 17px 20px;
    width: 100%;

    :nth-child(1) {
      max-width: 945px;
      margin-right: 3px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    :nth-child(2) {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      max-width: 295px;
    }
  }
`;

const FinishFinalist = styled(FinishCard)`
  height: 86px;
  cursor: pointer;

  :not(:last-child) {
    margin-bottom: 3px;
  }

  div {
    border-width: 3px;
    border-style: solid;
    border-color: #ffffff;
    border-radius: 10px;
    background-color: #ffffff;

    :nth-child(2) {
      border-left: none;
      border-top-left-radius: initial;
      border-bottom-left-radius: initial;
    }

    :nth-child(1) {
      border-right: none;
      border-top-right-radius: initial;
      border-bottom-right-radius: initial;
    }

    p {
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      margin: 0;
    }
  }

  color: #000000;
`;

export default () => {
  const history = useHistory();
  const getJuries = useQuery(GET_JURIES, { fetchPolicy: "no-cache" });
  const subscribeJuries = useSubscription(SUB_JURIES);
  const [scores, setScores] = useState([]);
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!getJuries.loading) {
      setScores(getJuries.data["users"]);
      setLoaded(true);
    }
  }, [getJuries.loading]);

  useEffect(() => {
    if (!subscribeJuries.loading && subscribeJuries.data.userUpdate) {
      juriesUpdate(subscribeJuries.data.userUpdate, scores, setScores);
    }
  }, [subscribeJuries.loading, subscribeJuries.data]);

  const handleJuries = (inx) => {
    history.push(`/juries/${inx}`);
  };

  return (
    <FinishSection>
      {isLoaded &&
        scores
          .filter((key) => !key.is_admin)
          .map((user, i) => {
            return (
              <FinishFinalist
                key={i}
                onClick={() => user.is_locked && handleJuries(user.id)}
              >
                <div>
                  <p>{user.login}</p>
                </div>
                <div>
                  {user.is_locked ? (
                    <p>сессия закончена</p>
                  ) : (
                    <Icons icon="iconClock" fill="#e4dada" />
                  )}
                </div>
              </FinishFinalist>
            );
          })}
    </FinishSection>
  );
};
